<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-sticky-note"></i><ng-container>&nbsp;</ng-container>
    <ng-container i18n *ngIf="!!data">Edit Comment</ng-container>
    <ng-container i18n *ngIf="!data">New Comment</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close" aria-label="Close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body p-0 bg-none m-0">
  <form [formGroup]="form" [formEditablePermission]="form">
    <mat-form-field2 [showLabel]="false">
      <textarea
        matInput
        #notes
        [maxlength]="maxLength"
        rows="8"
        formControlName="note"
        placeholder="Type your comments here.."
        i18n-placeholder
        cdkTextareaAutosize
      ></textarea>
      <mat-error *ngIf="form.get('note').touched && form.get('note').hasError('required')" class="pl-3">
        <ng-container i18n>Comment is required</ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('note').touched && form.get('note').hasError('maxLength')" class="pl-3">
        <ng-container i18n>Comment must be at most 500 characters long</ng-container>
      </mat-error>
      <mat-hint align="end" class="pr-3">{{ notes.value.length }} / {{ maxLength }}</mat-hint>
    </mat-form-field2>
  </form>
</div>
<div class="modal-footer">
  <button *ngIf="data" (click)="delete()" type="button" class="btn btn-secondary-danger">
    <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>delete</ng-container>
  </button>
  <div class="flex-fill"></div>
  <button (click)="close()" type="button" [disabled]="1 | isReadonlyRole" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="save(form)" [disabled]="1 | isReadonlyRole" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>save</ng-container>
  </button>
</div>
